import { Component } from 'react';

class EmptyFilters extends Component {
  render() {
    let styles = {
      padding: '0 15px 15px 15px',
    };
    let filterTitleStyle = {
      margin: '15px 0',
      fontSize: '16px',
    };
    return (
      <div style={styles} className="row">
        <div className="col-md-4">
          <h4 style={filterTitleStyle}>Team member name</h4>
          <input className="form-control" />
        </div>
        <div className="col-md-4">
          <h4 style={filterTitleStyle}>Start date</h4>
          <input className="form-control" />
        </div>
        <div className="col-md-4">
          <h4 style={filterTitleStyle}>End date</h4>
          <input className="form-control" />
        </div>
      </div>
    );
  }
}

export default EmptyFilters;
